import React from 'react'


const Error = () => {
  return (
    <section className='w-full h-screen items-center justify-center flex flex-col gap-2'>
        <h1 className='text-2xl font-semibold '>Sorry dear!</h1>
        <p className='text-6xl font-bold'>404</p>
        <p className='font-bold'>Page not found</p>
    </section>
  )
}

export default Error
